import { useTranslation } from "@l2r-front/l2r-i18n"
import { RestoreIcon } from "@l2r-front/l2r-icons"
import { PropTypes } from "@l2r-front/l2r-proptypes"
import { L2RButton, useIsMobileDevice } from "@l2r-front/l2r-ui"

import { I18N_NAMESPACE } from "../../constants/i18n"

import { StabiloModeButton } from "../StabiloModeButton/StabiloModeButton"

import * as Styled from "./StabiloControls.styled"

export function StabiloControls(props) {
    const {
        modes,
        mode,
        onChange,
        onRestore,
        restorable,
    } = props

    const isMobile = useIsMobileDevice()
    const { t } = useTranslation(I18N_NAMESPACE)

    const handleToggleChange = (_, newMode) => {
        if (newMode && modes[newMode].brushes?.length === 1) {
            onChange(newMode, { brush: modes[newMode].brushes[0] })
        }
    }

    return <Styled.Container>
        <Styled.ToggleButtonGroup
            id="linear-edit-modes"
            exclusive
            value={mode}
            onChange={handleToggleChange}
        >
            {
                Object.entries(modes).map(([modeKey, modeConfig]) => (
                    <StabiloModeButton
                        key={modeKey}
                        config={{
                            value: modeKey,
                            icon: modeConfig.icon,
                            colors: modeConfig.brushes,
                        }}
                        isSelected={mode === modeKey}
                        onColorPick={(btnValue, brush) => onChange(btnValue, { brush: brush })}
                    />
                ))
            }
        </Styled.ToggleButtonGroup>
        {!isMobile ? <L2RButton
            id="linear-edit-reset"
            disabled={!restorable}
            variant="secondary"
            startIcon={<RestoreIcon />}
            onClick={onRestore}>
            {t(I18N_NAMESPACE, "components.stabiloControls.restore")}
        </L2RButton> :
            <Styled.RestoreButton disabled={!restorable} onClick={onRestore} >
                <RestoreIcon />
            </Styled.RestoreButton>
        }
    </Styled.Container >
}

StabiloControls.propTypes = {
    mode: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    onRestore: PropTypes.func.isRequired,
    restorable: PropTypes.bool,
}

StabiloControls.defaultProps = {
    restorable: false,
}